module.exports = __webpack_public_path__ + "1791188489487/fonts/Metropolis-Bold.74938f5.woff";